
export const CATEGORY_STRUCTURE = [
    {
        name: "AI & Intelligence",
        subcategories: [
            "Chatbots & Assistants", "RAG & Knowledge Base", "Prompt Agents", "Decision Engines", "Classification & Tagging", "Sentiment Analysis", "Predictive AI", "Voice AI"
        ]
    },
    {
        name: "Data Extraction (Scraping & Mining)",
        subcategories: [
            "Website Scraping", "Google Dorks", "Google Maps Scraping", "Social Media Scraping", "Marketplace Scraping", "Directory Scraping", "API Data Pulling", "File Imports"
        ]
    },
    {
        name: "Data Processing & Enrichment",
        subcategories: [
            "Data Cleaning", "Deduplication", "Normalization", "Validation", "Field Mapping", "Merging & Joining", "Data Enrichment", "Translation"
        ]
    },
    {
        name: "Lead Generation & Prospecting",
        subcategories: [
            "Local Business Leads", "B2B Leads", "Ecommerce Leads", "Influencer Leads", "SaaS Leads", "Agency Leads", "Real Estate Leads", "ICP Targeting"
        ]
    },
    {
        name: "Outreach & Engagement",
        subcategories: [
            "Cold Email", "Follow-Up Sequences", "SMS Campaigns", "WhatsApp Messaging", "Telegram Bots", "LinkedIn DM Automation", "Appointment Setting"
        ]
    },
    {
        name: "Marketing & Growth",
        subcategories: [
            "SEO", "Ads Copy", "Social Media Content", "Influencer Marketing", "Funnels", "Conversion Optimization", "Brand Building"
        ]
    },
    {
        name: "Ecommerce & Monetization",
        subcategories: [
            "Shopify", "WooCommerce", "Marketplaces", "Dropshipping", "Product Research", "Price Monitoring", "Reviews & Ratings"
        ]
    },
    {
        name: "Automation & Workflow Engines",
        subcategories: [
            "Workflow Builder", "Triggers & Events", "Schedulers", "Webhooks", "API Connectors", "Conditional Logic", "Error Handling"
        ]
    },
    {
        name: "Files, Documents & Data Sources",
        subcategories: [
            "PDF Processing", "OCR", "Document Parsing", "Resume Parsing", "Invoice Extraction", "Audio Transcription", "Spreadsheet Imports"
        ]
    },
    {
        name: "Output, Export & Delivery",
        subcategories: [
            "CSV & Excel Export", "Google Sheets Export", "CRM Export", "PDF Reports", "Branded Reports", "Dataset Downloads", "API Output"
        ]
    },
    {
        name: "Creative, Images & Media AI",
        subcategories: [
            "Image Generation", "Logo Tools", "Background Removal", "Image Upscaling", "Transparent PNG", "Thumbnails", "Ad Creatives", "Brand Kits"
        ]
    },
    {
        name: "Security, Compliance & Validation",
        subcategories: [
            "Email Verification", "Phone Validation", "Spam Detection", "GDPR Compliance", "Fraud Detection", "Proxy & IP Control"
        ]
    },
    {
        name: "Integrations & Connectors",
        subcategories: [
            "Google Sheets", "Airtable", "CRMs", "Zapier", "Slack & Discord", "Email Providers", "SMS Providers", "Custom APIs"
        ]
    },
    {
        name: "Analytics, BI & Reporting",
        subcategories: [
            "Dashboards", "Funnel Analytics", "Lead Performance", "Campaign ROI", "Attribution", "A/B Testing", "Usage Analytics"
        ]
    }
];

export const CATEGORIES = ["All", "Free", ...CATEGORY_STRUCTURE.map(c => c.name)];

export const TAG_MAPPING: Record<string, string> = {
    // Main Categories
    "AI & Intelligence": "ai-intel",
    "Data Extraction (Scraping & Mining)": "data-extract",
    "Data Processing & Enrichment": "data-process",
    "Lead Generation & Prospecting": "lead-gen",
    "Outreach & Engagement": "outreach",
    "Marketing & Growth": "marketing",
    "Ecommerce & Monetization": "ecommerce",
    "Automation & Workflow Engines": "automation",
    "Files, Documents & Data Sources": "files-docs",
    "Output, Export & Delivery": "output",
    "Creative, Images & Media AI": "creative-ai",
    "Security, Compliance & Validation": "security",
    "Integrations & Connectors": "integrations",
    "Analytics, BI & Reporting": "analytics",

    // Subcategories - AI & Intelligence
    "Chatbots & Assistants": "chatbot",
    "RAG & Knowledge Base": "rag",
    "Prompt Agents": "prompt",
    "Decision Engines": "decision",
    "Classification & Tagging": "classify",
    "Sentiment Analysis": "sentiment",
    "Predictive AI": "predict",
    "Voice AI": "voice",

    // Subcategories - Data Extraction
    "Website Scraping": "webscrape",
    "Google Dorks": "dorks",
    "Google Maps Scraping": "maps",
    "Social Media Scraping": "social",
    "Marketplace Scraping": "market",
    "Directory Scraping": "directory",
    "API Data Pulling": "api",
    "File Imports": "import",

    // Subcategories - Data Processing
    "Data Cleaning": "clean",
    "Deduplication": "dedupe",
    "Normalization": "normalize",
    "Validation": "validate",
    "Field Mapping": "map",
    "Merging & Joining": "merge",
    "Data Enrichment": "enrich",
    "Translation": "translate",

    // Subcategories - Outreach
    "Local Business Leads": "local",
    "B2B Leads": "b2b",
    "Ecommerce Leads": "ecom",
    "Influencer Leads": "influencer",
    "SaaS Leads": "saas",
    "Agency Leads": "agency",
    "Real Estate Leads": "realestate",
    "ICP Targeting": "icp",

    // Subcategories - Marketing
    "SEO": "seo",
    "Ads Copy": "ads",
    "Social Media Content": "smcontent",
    "Influencer Marketing": "influencer",
    "Funnels": "funnel",
    "Conversion Optimization": "cro",
    "Brand Building": "brand",

    // Subcategories - Ecommerce
    "Shopify": "shopify",
    "WooCommerce": "woo",
    "Marketplaces": "marketplace",
    "Dropshipping": "dropship",
    "Product Research": "product",
    "Price Monitoring": "price",
    "Reviews & Ratings": "reviews",

    // Subcategories - Automation
    "Workflow Builder": "workflow",
    "Triggers & Events": "trigger",
    "Schedulers": "schedule",
    "Webhooks": "webhook",
    "API Connectors": "apiconn",
    "Conditional Logic": "logic",
    "Error Handling": "errors",

    // Subcategories - Files
    "PDF Processing": "pdf",
    "OCR": "ocr",
    "Document Parsing": "docparse",
    "Resume Parsing": "resume",
    "Invoice Extraction": "invoice",
    "Audio Transcription": "audio",
    "Spreadsheet Imports": "sheet",

    // Subcategories - Output
    "CSV & Excel Export": "csv",
    "Google Sheets Export": "sheets",
    "CRM Export": "crm",
    "PDF Reports": "pdfreport",
    "Branded Reports": "brandrep",
    "Dataset Downloads": "download",
    "API Output": "apiout",

    // Subcategories - Creative
    "Image Generation": "imggen",
    "Logo Tools": "logo",
    "Background Removal": "bgremove",
    "Image Upscaling": "upscale",
    "Transparent PNG": "png",
    "Thumbnails": "thumb",
    "Ad Creatives": "adcreative",
    "Brand Kits": "brandkit",

    // Subcategories - Security
    "Email Verification": "emailverify",
    "Phone Validation": "phoneverify",
    "Spam Detection": "spam",
    "GDPR Compliance": "gdpr",
    "Fraud Detection": "fraud",
    "Proxy & IP Control": "proxy",

    // Subcategories - Integrations
    "Google Sheets": "gsheets",
    "Airtable": "airtable",
    "CRMs": "crm",
    "Zapier": "zapier",
    "Slack & Discord": "slack",
    "Email Providers": "emailprov",
    "SMS Providers": "smsprov",
    "Custom APIs": "customapi",

    // Subcategories - Analytics
    "Dashboards": "dashboard",
    "Funnel Analytics": "funnel",
    "Lead Performance": "leadperf",
    "Campaign ROI": "roi",
    "Attribution": "attrib",
    "A/B Testing": "abtest",
    "Usage Analytics": "usage"
};
